/**
 * Sort an array of strings alphabetically.
 *
 * Example Usage:
 * - sortStringArray(['b', 'a', 'c']) -> ['a', 'b', 'c']
 */
export const sortStringArray = (arr?: string[]): string[] | undefined => {
  return arr?.sort((a, b) => a?.localeCompare?.(b))
}
